export const BookingProviders = {
  en: {
    Name: 'Name',
    'Create Booking Provider': 'Create Booking Provider',
    Provider: 'Provider',
    spot: 'spot',
    trainer: 'trainer',
    Active: 'Active',
  },
  uk: {
    Name: 'Назва',
    'Create Booking Provider': 'Створити букінг провайдер',
    Provider: 'Провайдер',
    spot: 'місце',
    trainer: 'тренер',
    Active: 'Активний',
  },
};

export const BookingProviderForm = {
  en: {
    ...BookingProviders.en,
    'New Booking Provider': 'New Booking Provider',
    'Edit Booking Provider': 'Edit Booking Provider',
    'Update Booking Provider': 'Update Booking Provider',
    'Provider Type': 'Provider Type',
    Description: 'Description',
    'Choose Image File': 'Choose Image File',
    Trainer: 'Trainer',
    Spot: 'Spot',
    'Booking services': 'Booking services',
    'Image aspect ratio should be 1:1': 'Image aspect ratio should be 1:1',
  },
  uk: {
    ...BookingProviders.uk,
    'New Booking Provider': 'Новий Провайдер',
    'Edit Booking Provider': 'Редагування Провайдера',
    'Update Booking Provider': 'Оновити Провайдер',
    'Provider Type': 'Тип провайдера',
    Description: 'Опис',
    'Choose Image File': 'Вибрати зображення',
    Trainer: 'Tренер',
    Spot: 'Місце',
    'Booking services': 'Букінг сервіси',
    'Image aspect ratio should be 1:1':
      'Співвідношення сторін зображення має бути 1:1',
  },
};
